import { all, call } from 'redux-saga/effects';

import auth from './auth';
import siteInfo from './siteInfo';
import navigation from './navigation';

/* App Launch */
import app from './app';

/* Active Questions */
import activeQuestions from '../../scenes/Home/services/sagas/activeQuestions';

/* Completed Questions */
import completedQuestions from '../../scenes/Home/services/sagas/completedQuestions';

/* Chatroom */
import chatroom from '../../scenes/Chat/services/sagas';

/* Cancel Question */
import uploadImage from '../../scenes/UploadImage/services/sagas/uploadImage';

/* PubNub ActiveQuestions */
import pubnubQuestionList from './pubnubQuestionList';

/* Curriculum */
import curriculum from './askQuestion';

/* Rate Question */
import rate from './rate';

/* Rate Question */
import questionQuota from './questionQuota';

/* Rate Question */
import questionListTutorial from './questionListTutorial';

/* Question Dialog */
import questionDialog from './questionDialog';

/* internet */
import internet from './internet';

/* Google Tag Manager Handler */
import googleTagManager from './googleTagManager';
import questionList from './questionList';
import openQuestion from './openQuestion';
import tutorial from './tutorial';

import report from './report';

/* bank */
import bank from './bank';

export default function* (context) {
  yield all([
    call(auth),
    call(siteInfo),
    call(chatroom),
    call(app),
    call(activeQuestions),
    call(completedQuestions),
    call(pubnubQuestionList),
    call(rate),
    call(navigation, context),
    call(uploadImage),
    call(curriculum),
    call(questionQuota),
    call(questionListTutorial),
    call(questionDialog),
    call(internet),
    call(googleTagManager),
    call(questionList),
    call(openQuestion),
    call(tutorial),
    call(report),
    call(bank),
  ]);
}



// WEBPACK FOOTER //
// ./src/services/sagas/index.js